(function () {
  angular.module('ticketco/ticketbuyer/redeem_items')
    .controller('redeemItemsDialogController', redeemItemsDialogController);

  function redeemItemsDialogController(ngDialog, RedeemItemsPersistence) {
    var self = this;
    self.loading = false;


    self.redeemCommand = function (model) {
      self.loading = true;
      return RedeemItemsPersistence.redeem(model)
        .then(function (res) {
          document.location.href = res.redirect_url;
          return res;
        })
        .catch(function (err) {
          self.loading = false;
          self.errors = err;
        });
    };

    self.reset = function (form) {
      form.errors = undefined;
      form.ngDialogData.token = undefined;
    };

  }

}());
